import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MakepaymentComponent} from './makepayment/makepayment.component'
import {PayreceiptComponent} from './payreceipt/payreceipt.component'
import { PaymentfailedComponent } from './paymentfailed/paymentfailed.component'
import { PendingComponent } from './pending/pending.component'
import { RefundComponent } from './refund/refund.component'
import {IsAuthenticatedGuard} from '../is-authenticated.guard'

const routes: Routes = [{path:'makepayment',component:MakepaymentComponent},
						{path:'makepayment/:challanNo',component:MakepaymentComponent},
                        {path:'receipt/:id',component:PayreceiptComponent},
                        {path:'failed',component:PaymentfailedComponent},
                        {path:'pending',component:PendingComponent, canActivate: [IsAuthenticatedGuard],
						    runGuardsAndResolvers: "always",
						    data: {
						        ROLES: ['VLE']
						    }},
                        {path:'refund',component: RefundComponent, canActivate: [IsAuthenticatedGuard],
						    runGuardsAndResolvers: "always",
						    data: {
						        ROLES: ['1001']
						    }}
						                        
						];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { 
  
}
